import { AppItem, ServiceItem } from "@/types/workspace"

export interface CacheApp {
  count: number
  maxCount: number
  asset: AppItem
}

export interface CategoryApp {
  categoryKey: string
  app: CacheApp[]
}

export interface CategoryItem<Asset extends AppItem | ServiceItem> {
  key: string
  type: `${ViewTabOption}`
  items: Asset[]
}

export interface InstanceDetails {
  connectionUrl: string | null
  password: string
}

export interface InsertedAppRegistry {
  app: AppItem | ServiceItem
  type: `${ViewTabOption}`
  count: number
}

export enum ViewTabOption {
  APPS = "apps",
  SERVICES = "services"
}

export interface DeployAction {
  workspaceId: string
  action: "retry" | "continue" | "cancel"
}
